enum GeneralPermissions {
  editAdminPanel = "EDIT_ADMIN_PANEL",
}

export default GeneralPermissions;
